/**
 * Resets a mapped document row to its initial state and unassigns it.
 * Removes the document mapping and clears all associated fields (entity type, assign to, debtor/creditor names, category).
 * @param caseAssignmentResult - Object containing mappedDocumentsIds array with mapped document information
 * @param rec - The current record/row being reset
 * @param assignedDocuments - Callback function to unassign the document
 * @param setRows - State setter function to update the rows data
 */
export const handleResetMappedDocument = (
  caseAssignmentResult: any,
  rec: any,
  assignedDocuments: ((args: { documentIds: number[] }) => void) | undefined,
  setRows: React.Dispatch<React.SetStateAction<any[]>>,
): void => {
  try {
    const mappedArr: any[] =
      (caseAssignmentResult && caseAssignmentResult.mappedDocumentsIds) || [];
    const mapped = mappedArr.find(
      (m) =>
        String(m.key) === String(rec.key) || m.key === rec.key,
    );
    const documentId =
      mapped &&
      (mapped.documentId ?? mapped.documentID ?? mapped.id);
    if (documentId && assignedDocuments) {
      assignedDocuments({
        documentIds: [Number(documentId)],
      });
    }

    setRows((prev: any[]) =>
      prev.map((r) =>
        r.key === rec.key
          ? {
              ...r,
              entityType: "",
              assignTo: "",
              debtorName: "",
              creditorName: "",
              category: "",
              mapped: false,
              canConfirm: false,
              loading: false,
              checked: false,
            }
          : r,
      ),
    );
  } catch (e) {
    setRows((prev: any[]) =>
      prev.map((r) =>
        r.key === rec.key
          ? {
              ...r,
              entityType: "",
              assignTo: "",
              debtorName: "",
              creditorName: "",
              category: "",
              mapped: false,
              canConfirm: false,
              loading: false,
              checked: false,
            }
          : r,
      ),
    );
  }
};
